import { DataActiveStatusEnum } from "../Category/types";
import { IImages } from "../product/types";

export interface IData {
  _id: string;
  title: string;
  shortDescription: string;
  longDescription: string;
  code: string;
  size: string;
  price: string;
  taxRate: string;
  sellingPrice: string;
  shipmentCapacity: string;
  status: DataActiveStatusEnum;
  categoryId: string;
  categoryTitle: string;
  images: IImages[];
  allergicImages: IImages[];
  stickers: IImages[];
  featuredImage: IImages[];
  createdAt: string;
  updatedAt: string;
}
export interface IExcelListData {
  _id: string;
  fileName: string;
  originalFileName: string;
  status: ExcelFileContentStatusEnum;
  createdAt: string;
  updatedAt: string;
}
export interface IExcelDetailsData {
  title: string;
  shortDescription: string;
  size: string;
  code: string;
  price: 700;
  sellingPrice: 500;
  taxRate: 12;
  images: string;
  productStatus: DataActiveStatusEnum;
  category: string;
  featuredImage: string;
  shipmentCapacity: 50;
  allergicImages: string;
  stickers: string;
  status: ExcelFileStatusEnum;
  _id: string;
  excelFileId: string;
  error: any[];
  createdAt: string;
  updatedAt: string;
}
export enum TypeEnum {
  Null = "Null",
  Single = "Single",
  Package = "Package",
}
export enum ExcelFileStatusEnum {
  PROCESSED = 1,
  PENDING = 2,
  PARTIALLY_PROCESSED = 3,
  PROCESSED_WITH_ERRORS = 4,
  PROCESSING = 5,
  FAILED = 6,
}
export enum ExcelFileContentStatusEnum {
  PROCESSED = 1,
  PENDING = 2,
  PARTIALLY_PROCESSED = 3,
  PROCESSED_WITH_ERRORS = 4,
  PROCESSING = 5,
  FAILED = 6,
}
export interface ProductRetailerState {
  formData: IData;
  list: IData[];
  allList: IData[];
  loading: boolean;
  buttonLoading: boolean;
  search: string;
  pageNo: number;
  pageSize: number;
  totalRow: number;
  orderBy: string;
  orderDir: string;
  toggleLoading: boolean;
  excelList: IExcelListData[];
  excelDetailsList: IExcelDetailsData[];
}

export type InitialState = ProductRetailerState;
